(() => {
  if (window.HNPreviewSignup) return;
  const initialize = (root, config) => {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const product = config.product;
    const messages = JSON.parse(root.querySelector('[data-hn-signup-messages]').textContent);
    const form = root.querySelector('form');
    const name = form.elements.first_name;
    const email = form.elements.email;
    const button = form.querySelector('button');
    const error = root.querySelector('[data-hn-signup-error]');
    const ready = root.querySelector('[data-hn-signup-ready]');
    root.querySelector('[data-hn-signup-title]').textContent = product.title;
    if (product.featuredImage?.url) {
      const image = document.createElement('img');
      const url = new URL(product.featuredImage.url);
      url.searchParams.set('width', '640');
      image.src = url.toString();
      image.alt = product.featuredImage.altText || product.title;
      image.width = product.featuredImage.width || 640;
      image.height = product.featuredImage.height || 640;
      image.loading = 'lazy';
      root.querySelector('[data-hn-signup-image]').replaceChildren(image);
    }
    name.addEventListener('input', () => name.setCustomValidity(''));
    const copy = root.querySelector('[data-hn-signup-copy]');
    copy?.addEventListener('click', async () => {
      const code = root.querySelector('[data-hn-signup-code]').textContent.trim();
      try { await navigator.clipboard.writeText(code); copy.textContent = messages.copied; } catch (_) { copy.textContent = code; }
      setTimeout(() => { copy.textContent = messages.copy; }, 2500);
    });
    let submitting = false;
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (submitting) return;
      name.value = name.value.trim();
      email.value = email.value.trim();
      name.setCustomValidity(name.value ? '' : messages.invalidName);
      if (!form.reportValidity()) return;
      error.hidden = true;
      submitting = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.classList.add('is-loading');
      button.textContent = messages.sending;
      const id = String(product.id).split('/').pop();
      const previewUrl = new URL('/pages/free-preview', 'https://heartsnotes.com');
      previewUrl.search = new URLSearchParams({pid: id, access: 'preview', utm_source: 'heartsnotes', utm_medium: 'email', utm_campaign: 'product-preview'}).toString();
      previewUrl.hash = new URLSearchParams({name: name.value}).toString();
      const params = new URLSearchParams(location.search);
      const payload = {
        email: email.value, first_name: name.value, product_id: id,
        product_title: product.title, product_handle: product.handle,
        product_type: product.productType || '', product_vendor: product.vendor || '',
        product_tags: product.tags || [], variant_id: product.variantId || product.selectedOrFirstAvailableVariant?.id || '',
        product_url: product.onlineStoreUrl || `https://heartsnotes.com/products/${product.handle}`,
        preview_url: previewUrl.toString(), source: 'heartsnotes_product_preview',
        preview_source: config.source, lead_intent: 'product_preview',
        discount_code: 'heartsnotes', marketing_consent: false,
        submitted_at: new Date().toISOString(), page_url: location.href, referrer: document.referrer,
        utm_source: params.get('utm_source') || '', utm_medium: params.get('utm_medium') || '', utm_campaign: params.get('utm_campaign') || ''
      };
      try {
        if (!config.webhookUrl || !product.previewFileUrl) throw new Error('Preview unavailable');
        if (!window.HNFormProtection) throw new Error('Verification unavailable');
        const protectedPayload = await window.HNFormProtection.prepareLead(payload, form);
        const response = await fetch(config.webhookUrl, {
          method: 'POST', signal: AbortSignal.timeout(45000),
          headers: {'Content-Type': 'text/plain;charset=UTF-8'}, body: JSON.stringify(protectedPayload)
        });
        const result = await response.json();
        if (!response.ok || result.success !== true || result.stored !== true) {
          const failure = new Error('Capture unconfirmed');
          failure.formMessage = window.HNFormProtection.message(result.code);
          throw failure;
        }
        const status = (messages[result.delivery] || messages.unconfirmed).replace('{email}', email.value);
        root.querySelector('[data-hn-signup-status]').textContent = status;
        root.querySelector('[data-hn-signup-ready-title]').textContent = (result.delivery === 'accepted' ? messages.readyAccepted : messages.readyOther).replace('{name}', name.value);
        const link = root.querySelector('[data-hn-signup-download]');
        // The button opens the same preview page the email links to (with the buy box), in a new tab.
        const onSiteUrl = new URL(previewUrl.toString());
        onSiteUrl.searchParams.set('utm_medium', 'product-page');
        link.href = onSiteUrl.toString();
        link.hidden = false;
        root.querySelector('[data-hn-signup-gate]').hidden = true;
        ready.hidden = false;
        root.querySelector('[data-hn-signup-overlay]').hidden = true;
        root.dataset.unlocked = 'true';
        ready.focus({preventScroll: true});
        root.dispatchEvent(new CustomEvent('hn:preview-ready', {bubbles: true, detail: {delivery: result.delivery, message: status, firstName: name.value}}));
      } catch (_error) {
        error.textContent = _error.formMessage || messages.error;
        error.hidden = false;
      } finally {
        submitting = false;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.classList.remove('is-loading');
        button.textContent = messages.submit;
      }
    });
  };
  const initializeProducts = (scope = document) => scope.querySelectorAll('[data-hn-preview-product-config]').forEach(node => {
    try { initialize(node.parentElement.querySelector('[data-hn-preview-signup]'), JSON.parse(node.textContent)); } catch (_) { /* Keep server-rendered content available. */ }
  });
  window.HNPreviewSignup = {initialize};
  initializeProducts();
  document.addEventListener('shopify:section:load', event => initializeProducts(event.target));
})();
